"use client";

import { useTheme } from "./ThemeProvider";

/**
 * 暗/亮主题拨动开关（移植预览 HTML）。
 * 暗色显示月亮、亮色显示太阳，thumb 在亮色右移 24px（由 CSS 控制）。
 */
export function ThemeSwitch() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <label
      className="theme-switch"
      role="switch"
      aria-checked={!isDark}
      tabIndex={0}
      aria-label="切换暗色 / 亮色"
      onClick={toggleTheme}
      onKeyDown={(e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          toggleTheme();
        }
      }}
    >
      <span className="track">
        <span className="thumb">
          <svg className="ic-moon" viewBox="0 0 24 24">
            <path d="M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8z" />
          </svg>
          <svg className="ic-sun" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
          </svg>
        </span>
      </span>
      <span>{isDark ? "暗色交易终端" : "机构金融亮色BI"}</span>
    </label>
  );
}
